/* @flow */
import PeopleListViewAllAnnouncementsDataContainer from './PeopleListViewAllAnnouncementsDataContainer';

export default PeopleListViewAllAnnouncementsDataContainer;
